import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlaneTop, faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';

import type { NotificationWrapperProps } from '@/components/notification/types';
import { cn } from '@/common/utils/clsx';

function NotificationWrapper({ title, help, status, children }: NotificationWrapperProps) {
  const isWarning = status === 'warning';
  const isSuccess = status === 'success';
  const isFinish = status === 'finished';
  const statusIconMap = {
    warning: faTriangleExclamation,
    success: faCircleCheck,
    finished: faPaperPlaneTop,
  } as const;

  const iconSelected = statusIconMap[status] ?? faTriangleExclamation;

  return (
    <div className="flex flex-col items-center justify-center px-4 font-light">
      <div
        className={cn('mb-4 flex h-9 w-9 items-center justify-center rounded-full text-white', {
          'bg-green': isSuccess,
          'bg-yellow': isWarning,
          'bg-blue': isFinish,
        })}
      >
        <FontAwesomeIcon icon={iconSelected} className="size-5" />
      </div>

      <h2 className={cn('text-center text-gray-900 text-3', { 'mb-2': !!help })}>{title}</h2>

      {help && <p className="mb-4 text-center text-gray-500">{help}</p>}

      {children}
    </div>
  );
}

export default NotificationWrapper;
